import { render, staticRenderFns } from "./OfferBadge.vue?vue&type=template&id=4cb790f2&scoped=true&"
import script from "./OfferBadge.vue?vue&type=script&lang=ts&"
export * from "./OfferBadge.vue?vue&type=script&lang=ts&"
import style0 from "./OfferBadge.vue?vue&type=style&index=0&id=4cb790f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb790f2",
  null
  
)

export default component.exports